import PropTypes from "prop-types";
import styled from "styled-components";

import { Placeholder } from "components/Placeholder";

const GradientLineChartPlaceholderContainer = styled.div`
  .custom-placeholder {
    min-height: ${({ height }) => height};
  }
`;

const GradientLineChartPlaceholder = ({ height }) => {
  return (
    <GradientLineChartPlaceholderContainer height={height}>
      <Placeholder className="custom-placeholder" />
    </GradientLineChartPlaceholderContainer>
  );
};

GradientLineChartPlaceholder.propTypes = {
  height: PropTypes.string,
};

export { GradientLineChartPlaceholder };
